import React from 'react';
import DeviceManagement from './DeviceManagement';
import { useTranslation } from 'react-i18next';

const Device: React.FC = () => {
  const { t } = useTranslation('device');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 className="font-bold text-title">{t('title')}</h6>
      <div className="bg-white rounded-md p-4">
        <DeviceManagement />
      </div>
    </section>
  );
};
export default Device;
